import { defineComponent as A, useAttrs as y, ref as I, computed as l, openBlock as g, createBlock as B, resolveDynamicComponent as V, mergeProps as F, createSlots as T, renderList as L, withCtx as x, renderSlot as P, normalizeProps as p, guardReactiveProps as S } from "vue";
import "@ds/components/Icon";
import { usePropsValidation as w } from "../../composables/usePropsValidation.js";
import { tw as s } from "../../utils/tailwind.js";
import { VariantsEnum as a, SizesEnum as z } from "./InputText.constant.js";
import $ from "./components/InputTextFixedLabel.vue2.js";
import j from "./components/InputTextFloatingLabel.vue2.js";
const G = /* @__PURE__ */ A({
  name: "RevInputText",
  inheritAttrs: !1,
  __name: "InputText",
  props: {
    autofocus: { type: Boolean, default: !1 },
    clearButtonAriaLabel: { default: () => {
    } },
    description: { default: () => {
    } },
    disabled: { type: Boolean, default: !1 },
    error: { default: () => {
    } },
    format: { type: Function, default: (t) => t },
    hasClearButton: { type: Boolean, default: !0 },
    helperTextClass: { type: [String, Boolean, Array, Object], default: () => s`` },
    icon: { default: () => {
    } },
    iconProps: { default: () => {
    } },
    id: {},
    inputClass: { type: [String, Boolean, Array, Object], default: () => s`` },
    label: {},
    modelValue: {},
    size: { default: "medium" },
    type: { default: "text" },
    required: { type: Boolean, default: !1 },
    variant: { default: () => a.Floating },
    startIcon: { default: () => {
    } },
    isLabelVisible: { type: Boolean, default: !0 },
    hasCustomAction: { type: Boolean, default: !1 },
    customActionIcon: { default: () => {
    } },
    inputContainerClass: { type: [String, Boolean, Array, Object], default: () => s`` }
  },
  emits: ["update:modelValue", "input", "invalid", "valid", "clear", "custom-action"],
  setup(t, { expose: c, emit: m }) {
    const o = m, r = y(), u = I(null), f = l(() => u.value?.input ?? null), v = l(
      () => u.value?.inputContainerId ?? null
    );
    c({
      input: f,
      inputContainerId: v
    });
    const b = l(() => t.variant === a.Fixed ? $ : j), C = l(() => {
      const i = {
        autofocus: t.autofocus,
        clearButtonAriaLabel: t.clearButtonAriaLabel,
        description: t.description,
        disabled: t.disabled,
        error: t.error,
        format: t.format,
        hasClearButton: t.hasClearButton,
        helperTextClass: t.helperTextClass,
        icon: t.icon,
        iconProps: t.iconProps,
        id: t.id,
        inputClass: t.inputClass,
        label: t.label,
        modelValue: t.modelValue,
        required: t.required,
        size: t.size,
        type: t.type
      };
      return t.variant === a.Fixed ? {
        ...i,
        startIcon: t.startIcon,
        hasCustomAction: t.hasCustomAction,
        isLabelVisible: t.isLabelVisible,
        customActionIcon: t.customActionIcon,
        inputContainerClass: t.inputContainerClass,
        ...r
      } : {
        ...i,
        ...r
      };
    });
    return w({
      'The `startIcon` prop cannot be used with the Floating label variant (`variant="floating"`).': () => t.variant === a.Floating && t.startIcon !== void 0,
      "The `isLabelVisible` prop doesn't have any effect on the Floating label variant (`variant='floating'`).": () => t.variant === a.Floating && !t.isLabelVisible,
      "The `isLabelVisible` prop doesn't have any effect on the Size small": () => t.size === z.Small && !t.isLabelVisible,
      'The `hasCustomAction` prop cannot be used with the Floating label variant (`variant="floating"`).': () => t.variant === a.Floating && t.hasCustomAction,
      'The `customActionIcon` prop cannot be used with the Floating label variant (`variant="floating"`).': () => t.variant === a.Floating && t.customActionIcon !== void 0,
      "The `customActionIcon` prop has to be defined when `hasCustomAction` is true": () => t.hasCustomAction && !t.customActionIcon,
      "The `hasCustomAction` prop should be set to true when `customActionIcon` is defined": () => t.customActionIcon !== void 0 && !t.hasCustomAction
    }), (i, e) => (g(), B(V(b.value), F(C.value, {
      ref_key: "inputComponent",
      ref: u,
      onClear: e[0] || (e[0] = (n) => o("clear")),
      onCustomAction: e[1] || (e[1] = (n) => o("custom-action")),
      onInput: e[2] || (e[2] = (n) => o("input", n)),
      onInvalid: e[3] || (e[3] = (...n) => o("invalid", ...n)),
      "onUpdate:modelValue": e[4] || (e[4] = (n) => o("update:modelValue", n)),
      onValid: e[5] || (e[5] = (n) => o("valid"))
    }), T({ _: 2 }, [
      L(i.$slots, (n, d) => ({
        name: d,
        fn: x((h) => [
          P(i.$slots, d, p(S(h)))
        ])
      }))
    ]), 1040));
  }
});
export {
  G as default
};
